import React from "react";
import { useNavigate } from "react-router-dom";

import "./PageABMs.css";

import Routes_gral from "../../utils/Routes_gral";

//Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faUsersBetweenLines,
  faUsers,
  faCoins,
  faCartShopping,
} from "@fortawesome/free-solid-svg-icons";

const PageABMs = () => {
  const navigate = useNavigate();

  const navigateTo = (abm) => {
    navigate(abm);
  };

  return (
    <div className="pageABMsView">
      <div className="multipleOptionsDiv">
        <div className="optionABMDiv">
          <button onClick={() => navigateTo(Routes_gral.provider)}>
            <FontAwesomeIcon icon={faCartShopping} className="iconAbm" />
            <label className="labelOptionABM">Proveedores</label>
          </button>
        </div>
        <div className="optionABMDiv">
          <button onClick={() => navigateTo(Routes_gral.subcuentas)}>
            <FontAwesomeIcon icon={faCoins} className="iconAbm" />
            <label className="labelOptionABM">Subcuentas</label>
          </button>
        </div>
        <div className="optionABMDiv">
          <button onClick={() => navigateTo(Routes_gral.user)}>
            <FontAwesomeIcon icon={faUsers} className="iconAbm" />
            <label className="labelOptionABM">Usuarios</label>
          </button>
        </div>
        <div className="optionABMDiv">
          <button onClick={() => navigateTo(Routes_gral.group)}>
            <FontAwesomeIcon icon={faUsersBetweenLines} className="iconAbm" />
            <label className="labelOptionABM">Grupos</label>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageABMs;